import { render, staticRenderFns } from "./PendingContest.vue?vue&type=template&id=7475c37c"
import script from "./PendingContest.vue?vue&type=script&lang=js"
export * from "./PendingContest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports